
  /**
   * @license
   * author: epignosis front-end team
   * @epignosis_llc/gnosis.js v6.0.0
   * Released under the MIT license.
   */

import { slicedToArray as _slicedToArray } from '../../../../_virtual/_rollupPluginBabelHelpers.js';
import '../../../../node_modules/core-js/modules/es.array.map.js';
import { useRef, useState, useEffect } from 'react';
import classNames from '../../../../node_modules/classnames/index.js';
import SvgChevronArrowDown from '../../../icons/chevrons/chevron-arrow-down.svg.js';
import Text from '../../Text/Text.js';
import useClickOutside from '../hooks.js';
import { PaginationSelectorStyles } from './styles.js';
import { createElement as jsx } from '../../../../node_modules/@emotion/react/dist/emotion-react.browser.esm.js';

var dropdownWrapperClasses = function dropdownWrapperClasses(placement) {
  return classNames({
    "dropdown-wrapper": true,
    bottom: placement === "bottom",
    top: placement === "top"
  });
};
var SelectedOptionClasses = function SelectedOptionClasses(isSelected) {
  return classNames({
    "is-selected": isSelected
  });
};
var PaginationSelector = function PaginationSelector(_ref) {
  var items = _ref.items,
    selected = _ref.selected,
    ariaLabel = _ref.ariaLabel,
    _ref$listPlacement = _ref.listPlacement,
    listPlacement = _ref$listPlacement === void 0 ? "top" : _ref$listPlacement,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    onClickItemHandler = _ref.onClickItemHandler;
  var wrapperRef = useRef(null);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isListOpen = _useState2[0],
    setIsListOpen = _useState2[1];
  var _useState3 = useState(selected),
    _useState4 = _slicedToArray(_useState3, 2),
    selectedListItem = _useState4[0],
    setSelectedListItem = _useState4[1];
  useClickOutside(wrapperRef, function () {
    return setIsListOpen(false);
  });
  var toggleList = function toggleList() {
    if (!disabled) {
      // We want to reset the dropdown list every time it opens
      setIsListOpen(function (prevState) {
        return !prevState;
      });
    }
  };
  var handleListItemSelect = function handleListItemSelect(item) {
    if (isListOpen) {
      onClickItemHandler(item);
      setSelectedListItem(item);
      setIsListOpen(false);
    }
  };
  useEffect(function () {
    setSelectedListItem(selected);
  }, [selected]);
  useEffect(function () {
    if (disabled) {
      setIsListOpen(false);
    }
  }, [disabled]);
  var hasItems = items.length > 1;
  return jsx("div", {
    css: function css(theme) {
      return PaginationSelectorStyles(theme, {
        isOpen: isListOpen
      });
    },
    ref: wrapperRef
  }, jsx("button", {
    className: "dropdown-button ".concat(!hasItems ? "disabled" : ""),
    disabled: !hasItems || disabled,
    onClick: toggleList,
    title: "".concat(selectedListItem),
    "aria-label": ariaLabel
  }, jsx(Text, {
    fontSize: "sm",
    weight: "700"
  }, selectedListItem), hasItems && jsx(SvgChevronArrowDown, null)), isListOpen && hasItems && jsx("div", {
    className: dropdownWrapperClasses(listPlacement)
  }, jsx("ul", {
    role: "list",
    className: "dropdown-list"
  }, items.map(function (_ref2) {
    var value = _ref2.value,
      label = _ref2.label;
    var isSelected = value === selectedListItem;
    return jsx("li", {
      className: "dropdown-list-item",
      "data-testid": "pagination-page",
      key: "item-".concat(value),
      title: "".concat(value),
      onClick: function onClick() {
        return handleListItemSelect(value);
      }
    }, jsx(Text, {
      fontSize: "sm",
      className: SelectedOptionClasses(isSelected)
    }, label));
  }))));
};

export { PaginationSelector as default };
//# sourceMappingURL=PaginationSelector.js.map
